export const INVOICE_STATUS_VALUES = [
  'DRAFT',
  'ISSUED',
  'SENT',
  'PAID',
  'OVERDUE',
  'CANCELLED',
  'CREDITED',
] as const

export type InvoiceStatusValue = (typeof INVOICE_STATUS_VALUES)[number]

export const BILLING_TRANSPORT_MODE_VALUES = ['ROAD', 'RAIL', 'SEA', 'AIR', 'INTERMODAL'] as const
export type BillingTransportModeValue = (typeof BILLING_TRANSPORT_MODE_VALUES)[number]

export const INVOICE_ENTITY_ID = 'billing:invoice'
